class Collection {

    constructor(resource, set, params) {
        if (resource._links) {
            this.url = resource._links.self.href;
        }
        this.$get = resource.$get;
        this.listeners = [];
    }

    find(id) {
        return this.items.find(item => item.id == id);
    }

    addItem(newItem) {
        this.items.push(newItem);
        this.callListeners(newItem, 'create');
    }

    updateItem(newItem) {
        const index = this.findIndex(newItem.id);
        if (index > -1) {
            this.items[index] = newItem;
            this.callListeners(newItem, 'update');
        } else {
            this.addItem(newItem);
        }
    }

    handlePush(push) {
        const newItem = push.object;
        switch (push.action) {
            case 'create':
                this.addItem(newItem);
                break;
            case 'update':
                this.updateItem(newItem);
                break;
            case 'destroy':
                this.pushDelete(push);
                break;
        }
    }

    findIndex(id) {
        return this.items.findIndex(item => item.id == id);
    }

    pushDelete(push) {
        const index = this.items.findIndex(item => item.$link('self').href == push.url);
        let obj = push.object;
        if (index > -1){
            obj =  this.items[index];
            this.items.splice(index, 1);
        }
        // only call the listeners if it was actaully in the collection oin the first place
        if (obj) this.callListeners(obj, 'destroy');
    }

    findListenerIndex(callback, context) {
        return this.listeners.findIndex((listener) => {
            return listener.callback == callback && listener.context == context;
        });
    }

    addListener(callback, context) {
        const index = this.findListenerIndex(callback, context);
        if (index == -1) this.listeners.push({callback, context});
    }

    callListeners(object, status) {
        for (const listener of this.listeners) listener.callback.call(listener.context, object, status);
    }

    removeListener(callback, context) {
        if (context) {
            const index = this.findListenerIndex(callback, context);
            if (index > -1) this.listeners.splice(index, 1);
        } else {
            this.listeners = this.listeners.filter(listener => listener.callback !== callback)
        }
    }

    listenForPush(set) {
        const index = set.findListenerIndex(this.handlePush, this);
        if (index == -1) set.addListener(this.handlePush, this);
    }

    static $query(collectionClass, set, company, params) {
        params = params || {};
        params['no_cache'] = true;
        const group = collectionClass.group;
        return new Promise((resolve, reject) => {
            const url = company.$href(group, params);
            if (set.collections[url]) {
                resolve(set.collections[url]);
            } else {
                return company.$get(group, params).then((resource) => {
                    let collection;
                    if (set.collections[resource.$link('self').href]) {
                        collection = set.collections[resource.$link('self').href];
                        resolve(collection);
                    } else {
                        collection = new (collectionClass)(resource, set, params);
                        if (!params.transient){
                            set.collections[resource.$link('self').href] = collection;
                        }
                        collection.promise.then(resolve);
                    }
                }, reject);
            }
        });
    }

    $refetch(set) {
        return new Promise((resolve, reject) => {
            return this.$get('self', {no_cache: true}).then((resource) => {
                const listeners = this.listeners;
                this.constructor(resource, set, this.params);
                this.promise.then((coll) => {
                    this.listeners = listeners;
                    resolve(coll);
                });
            }, reject);
        });
    }

}

export {
    Collection
}
